import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const templates = {
	// 获取简历模板详情
	getTemplateDetail: token => {
		return api.get(proxyApi + `/v3/sample_cvs/${token}`)
	},
	// 获取未登录6个大牛简历案例
	getTemplateCase: payload => {
		return api.get(proxyApi + '/v3/sample_cvs', payload)
	}
}

export default templates
